export default __webpack_public_path__ + "static/media/1.0ab5815a.jpg";